import { render, staticRenderFns } from "./UsersPrivilegeEmployeeSalarySetting.vue?vue&type=template&id=5875a03d&scoped=true&"
import script from "./UsersPrivilegeEmployeeSalarySetting.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeEmployeeSalarySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5875a03d",
  null
  
)

export default component.exports